import { render } from "./ShortDescription.vue?vue&type=template&id=0c69ca82"
import script from "./ShortDescription.vue?vue&type=script&lang=js"
export * from "./ShortDescription.vue?vue&type=script&lang=js"

import "./ShortDescription.vue?vue&type=style&index=0&id=0c69ca82&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__